import { useEffect, useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// value: null = all entities, array = only those entity ids
export const EntityAccessPicker = ({ entities, value, onChange, testId = "entity-access" }) => {
  const all = value === null;
  const toggle = (id, on) => onChange(on ? [...(value || []), id] : (value || []).filter((x) => x !== id));
  return (
    <div className="space-y-3" data-testid={testId}>
      <label className="flex items-center gap-3 text-sm">
        <Switch checked={all} onCheckedChange={(v) => onChange(v ? null : [])} data-testid={`${testId}-all-switch`} />
        Access to all entities {all && <span className="text-xs text-muted-foreground">(including ones added later)</span>}
      </label>
      {!all && (
        <div className="grid sm:grid-cols-2 gap-2 max-h-56 overflow-y-auto rounded-lg border border-border p-3">
          {entities.length === 0 && <span className="text-xs text-muted-foreground">No entities yet.</span>}
          {entities.map((e) => (
            <label key={e.id} className="flex items-center gap-2 text-sm">
              <Checkbox checked={(value || []).includes(e.id)} onCheckedChange={(v) => toggle(e.id, !!v)} data-testid={`${testId}-check-${e.id}`} />
              <span className="truncate">{e.name}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export const accessLabel = (ids, entities) => {
  if (ids == null) return "All entities";
  const names = entities.filter((e) => ids.includes(e.id)).map((e) => e.name);
  return names.length <= 2 ? names.join(", ") || "No entities" : `${names.length} entities`;
};

export const AccessDialog = ({ member, entities, onClose, onSave }) => {
  const [value, setValue] = useState(null);
  useEffect(() => {
    if (member) setValue(member.entity_ids ?? null);
  }, [member]);
  return (
    <Dialog open={!!member} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="access-dialog">
        <DialogHeader><DialogTitle>Entity access · {member?.email}</DialogTitle></DialogHeader>
        <EntityAccessPicker entities={entities} value={value} onChange={setValue} testId="access-edit" />
        <Button className="w-full" disabled={Array.isArray(value) && value.length === 0} onClick={() => onSave(value)} data-testid="access-save-btn">Save access</Button>
      </DialogContent>
    </Dialog>
  );
};
